module.exports = __webpack_public_path__ + "static/media/environment-waste.5c80fcca.svg";